import { useRef, useEffect } from 'react';

/* Utils used by multiple roles */
const sortAlphabetical = (arr, key) => {
	return arr.sort((a, b) => a[key].localeCompare(b[key]));
};

const asyncFlush = () => new Promise((resolve) => setTimeout(resolve, 0));

const deepUpdate = async (wrapper) => {
	await asyncFlush();
	await wrapper.update();
};

const usePrevious = (value) => {
	const ref = useRef();
	 useEffect(() => {
		 ref.current = value;
	 }, [value]);
	 return ref.current;
};

export {
	asyncFlush,
	sortAlphabetical,
	deepUpdate,
	usePrevious,
};
